import TimeseriesWidget from "../timeseries_widget/timeseries_widget";
import withFilteredObservationAggregations from "../../observation_hocs/with_filtered_observation_aggregations";

export default withFilteredObservationAggregations(TimeseriesWidget);
